export const formatDate = value => {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return date.toLocaleDateString("pt-BR");
};

export const formatTime = value => {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    return date.toLocaleTimeString("pt-BR", {hour: "2-digit", minute: "2-digit"});
};

export const formatElapsed = (start, end) => {
    if (!start) return "";

    const startDate = new Date(start);
    const endDate = end ? new Date(end) : new Date();

    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return "";

    const diffMinutes = Math.max(0, Math.floor((endDate.getTime() - startDate.getTime()) / 60000));
    const days = Math.floor(diffMinutes / 1440);
    const hours = Math.floor((diffMinutes % 1440) / 60);
    const minutes = diffMinutes % 60;

    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}min`;
    return `${minutes}min`;
};

export const formatList = value => {
    if (Array.isArray(value)) return value.filter(Boolean).join(", ");
    return value || "";
};

export const formatCaseCard = (content) => {
    if (!content) return "";
    return content.toLowerCase().
        replace(/(^\p{L})|(\/\p{L})|(,\p{L})|(-+\p{L})|(\s+\p{L})/gu, letter => letter.toUpperCase());
}
